import cn from 'classnames';
import s from './style.css';

const LookCloser = ({ sized }) => (
	<div className={cn(s.container, { [s.sized]: sized })}>
		<div className={s.inner}>
			<div className={s.emoji}>🔍</div>
			<div className={s.arrow} />
			<p className={s.text}>Look closer</p>
		</div>
	</div>
);

export default LookCloser;



// WEBPACK FOOTER //
// ./components/LookCloser/index.js